import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';

const Amenities = () => {
  const popularFacilities = [
    "Outdoor pool",
    "Free Wi-Fi",
    "Airport shuttle",
    "Beachfront",
    "Restaurant",
    "Spa & wellness center",
    "Non-smoking rooms",
    "Room service",
    "Bar",
    "Breakfast"
  ];

  return (
    // Increased top padding from pt-24 to pt-36
    <div className="page-transition pt-36 pb-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl mb-6">Amenities & Services</h1>
          <p className="text-lg text-brand-600">Everything you need for a comfortable stay.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
          <div className="bg-white p-8 rounded-lg shadow-sm">
            <h2 className="text-2xl mb-6 text-brand-800">Most Popular Facilities</h2>
            <ul className="space-y-4">
              {popularFacilities.map((item, idx) => (
                <li key={idx} className="flex items-center gap-3 text-brand-700">
                  <FiCheckCircle className="text-brand-500" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-8">
            <div className="bg-brand-50 p-8 rounded-lg">
              <h2 className="text-2xl mb-4 text-brand-800">Parking</h2>
              <p className="text-brand-700">
                Free private parking is available on site, reservation required.
              </p>
            </div>
            
            <div className="bg-brand-50 p-8 rounded-lg">
              <h2 className="text-2xl mb-4 text-brand-800">Internet</h2>
              <p className="text-brand-700">
                WiFi is available in the hotel rooms and is free of charge.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Amenities;